import React from "react";
import "../ExperienceCard.css";

export default function ExperienceCard({ company, position, date, description }) {
  return (
    <div className="experience-card">
      <div className="experience-left">
        <h3 className="experience-company">{company}</h3>
        <p className="experience-position">{position}</p>
      </div>
      <p className="experience-description">{description}</p>
      {date && <p className="experience-date">{date}</p>}
    </div>
  );
}
